import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    value: {
        selectedRecipePage: number;
        allRecipes: any[];
        recipesLoading: boolean;
        selectedRecipeId?: string;
        selectedRecipeData?: any;
    }
};

const initialState = {
    value: {
        selectedRecipePage: 1,
        allRecipes: [],
        recipesLoading: false,
        selectedRecipeId: '',
        selectedRecipeData: null,
    }
} as InitialState;

export const recipeSlice = createSlice({
    name: 'recipe',
    initialState,
    reducers: {
        setSelectedRecipePage: (state, action) => {
            state.value.selectedRecipePage = action.payload;
        },
        setAllRecipes: (state, action) => {
            state.value.allRecipes = action.payload;
        },
        setRecipesLoading: (state, action) => {
            state.value.recipesLoading = action.payload;
        },
        setSelectedRecipeId: (state, action) => {
            state.value.selectedRecipeId = action.payload;
        },
        setSelectedRecipeData: (state, action) => {
            state.value.selectedRecipeData = action.payload;
        },
        updateSelectedRecipeData: (state, action) => {
            const { key, value } = action.payload;
            if (state.value.selectedRecipeData && key in state.value.selectedRecipeData) {
                state.value.selectedRecipeData[key] = value;
            } else {
                console.warn(`Key "${key}" is not found in selectedRecipeData`);
            }
        },
    },
});

export const {
    setSelectedRecipePage,
    setAllRecipes,
    setRecipesLoading,
    setSelectedRecipeId,
    setSelectedRecipeData,
    updateSelectedRecipeData,
} = recipeSlice.actions;
export default recipeSlice.reducer;